// Import from NPM
// -------------------------------------
import React, { Component } from "react";
import localforage from "localforage";
import _ from "lodash";
import { Router, Route, hashHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import loadable from "@loadable/component";
import "semantic-ui-css/semantic.min.css";
import "config/overrule.css";

// Import from Config
// -------------------------------------
import {
    Store,
    persistStore,
    persistStoreConfig,
} from "backend/storage/mobile/mobile.store";
import { getAppConfig } from "config/client.config";
import { appConfig } from "config/initializers/config.app";
import { Loading } from "mobile/appComponents/loading/Loading.react";
import ErrorPage from "globals/error/ErrorPage.react";

// Import Routes
// -------------------------------------
const AuthenticationContainer = loadable(
    () => import("mobile/authentication/AuthenticationContainer.react"),
    {
        fallback: <Loading />,
    }
);
const SessionContainer = loadable(
    () => import("mobile/home/SessionContainer.react"),
    {
        fallback: <Loading />,
    }
);
const HomeContainer = loadable(
    () => import("mobile/home/HomeContainer.react"),
    {
        fallback: <Loading />,
    }
);
const CityContainer = loadable(
    () => import("mobile/home/CityContainer.react"),
    {
        fallback: <Loading />,
    }
);
const FilmCityHRContainer = loadable(
    () => import("mobile/home/FilmCityHRContainer.react"),
    {
        fallback: <Loading />,
    }
);
const CityFestivalContainer = loadable(
    () => import("mobile/home/CityFestivalContainer.react"),
    {
        fallback: <Loading />,
    }
);
const FilmCityTestContainer = loadable(
    () => import("mobile/home/FilmCityTestContainer.react"),
    {
        fallback: <Loading />,
    }
);
const GlobeMapContainer = loadable(
    () => import("mobile/home/GlobeMapContainer.react"),
    {
        fallback: <Loading />,
    }
);
const IpSosContainer = loadable(
    () => import("mobile/home/IpSosContainer.react"),
    {
        fallback: <Loading />,
    }
);
const Content = loadable(() => import("mobile/blog/ContentContainer.react"), {
    fallback: <Loading />,
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rehydrated: false,
        };
        this.requireLogin = this.requireLogin.bind(this);
        this.alreadyLoggedIn = this.alreadyLoggedIn.bind(this);
        this.manageStore = window.manageStore = this.manageStore.bind(this);
        this.appType = window.appType = "mobile";
        this.manageStore();
    }

    manageStore = (purge) => {
        if (purge === "purge") {
            console.log("Purging Store...");
            persistStore(Store, persistStoreConfig).purge();
        } else {
            if (window.localStorage) {
                persistStore(Store, persistStoreConfig, () => {
                    let existing_user =
                        window.localStorage.getItem("reduxPersist:auth");
                    if (existing_user) {
                        localforage.setItem("reduxPersist:auth", existing_user);
                    } else {
                        console.log("Session initiated");
                    }
                    this.setState({ rehydrated: true });
                });
            }
        }
    };

    requireLogin(nextState, replace, callback) {
        let targetPath = window.location.href.split("#/")[1]; // Get the URL that you are trying to get to
        let userLoggedIn = Store.getState().auth.isUserLoggedIn;
        let hasToken = _.includes(targetPath, "token");
        //--------------------------------------------------------
        // If the user is not logged in and there is no token in the url (Redirect to Login Page)
        //--------------------------------------------------------
        if (!userLoggedIn && !hasToken) {
            console.log("Unauthorized. Redirect to Login Page");
            // Redirect to local login path if login path is local
            if (appConfig.auth.routes.login.indexOf("http") === -1)
                replace(appConfig.auth.routes.login);
            // Redirect to external login path if login path is external
            // with the target path as the referrer
            else
                window.location = appConfig.auth.routes.login.replace(
                    "login",
                    targetPath.split("?")[0]
                );
            callback();
        }

        //--------------------------------------------------------
        // If the user is not logged in and there is a token in the url (Start Login Process)
        //--------------------------------------------------------
        else if (!userLoggedIn && hasToken) {
            console.log("Unauthorized. Token Login process started.");
            if (
                _.includes(targetPath, "login") ||
                _.includes(targetPath, "logout") ||
                _.includes(targetPath, "session")
            )
                targetPath = "home";
            localforage
                .setItem("lastLocation", targetPath.split("?")[0])
                .then(() => {
                    replace("/login?token=" + targetPath.split("?token=")[1]);
                    callback();
                })
                .catch((error) => {
                    console.log("Error: Unable to set last location", error);
                });
        }
        //--------------------------------------------------------
        // If the user is logged in and there is a token in the url (Honour Token Process)
        //--------------------------------------------------------
        // else if (
        //     userLoggedIn && hasToken &&
        //     Store.getState().auth.user.username.startsWith("ip") &&
        //     !_.includes(targetPath, "session")
        // ) {
        //     let newToken = targetPath.split("?token=")[1];
        //     console.log("Unauthorized. Honour Token process started.");
        //     localforage
        //         .removeItem("tokenHash", null)
        //         .then(() => {
        //             Promise.resolve(
        //                 Store.dispatch({ type: LOGOUT, status: "success" })
        //             )
        //                 .then(() => {
        //                     if (
        //                         targetPath === "" ||
        //                         _.includes(targetPath, "login") ||
        //                         _.includes(targetPath, "logout") ||
        //                         _.includes(targetPath, "session")
        //                     )
        //                         targetPath = "home";
        //                     localforage
        //                         .setItem(
        //                             "lastLocation",
        //                             targetPath.split("?")[0]
        //                         )
        //                         .then(() => {
        //                             replace("/login?token=" + newToken);
        //                             callback();
        //                         })
        //                         .catch((error) => {
        //                             console.log(
        //                                 "Error: Unable to set last location",
        //                                 error
        //                             );
        //                         });
        //                 })
        //                 .catch((error) => {
        //                     console.log(
        //                         "Error: Unable to dispatch logout",
        //                         error
        //                     );
        //                 });
        //         })
        //         .catch((error) => {
        //             console.log("Error: Unable to remove tokenHash", error);
        //         });
        // }
        //--------------------------------------------------------
        // If the user is logged in and there is no token in the url (Okay to Proceed)
        //--------------------------------------------------------
        else {
            callback(); // Proceed as usual
        }
    }

    alreadyLoggedIn(nextState, replace, callback) {
        if (Store.getState().auth.isUserLoggedIn)
            replace(getAppConfig().auth.routes.afterSignIn);
        callback();
    }

    render() {
        let isPortrait = window.innerHeight > window.innerWidth;
        let returnValue = (
            <div
                style={{
                    ...getAppConfig().appStyle,
                    height: "100%",
                    padding: isPortrait ? "0" : "10px",
                    position: "relative",
                    overflow: isPortrait ? "hidden" : "visible",
                }}
            >
                <Router history={syncHistoryWithStore(hashHistory, Store)}>
                    <Route component={AuthenticatedLayout}>
                        <Route
                            exact
                            path="/"
                            component={SessionContainer}
                            onEnter={this.requireLogin}
                        />
                        <Route
                            exact
                            path="/home"
                            component={HomeContainer}
                            onEnter={this.requireLogin}
                        />
                        <Route
                            path="/content/:id(/:slug)"
                            component={Content}
                            onEnter={this.requireLogin}
                        />
                        <Route
                            path="/session(/:autoRoute)"
                            component={SessionContainer}
                            onEnter={this.requireLogin}
                        />
                    </Route>
                    <Route component={UnauthenticatedLayout}>
                        <Route
                            path="/login"
                            component={AuthenticationContainer}
                            onEnter={this.alreadyLoggedIn}
                        />
                        <Route
                            path="/admin"
                            component={AuthenticationContainer}
                            onEnter={this.alreadyLoggedIn}
                        />
                        <Route
                            path="/logout"
                            component={AuthenticationContainer}
                            onEnter={this.requireLogin}
                        />
                        <Route
                            path="/signup"
                            component={AuthenticationContainer}
                            onEnter={this.alreadyLoggedIn}
                        />
                        <Route
                            path="/forgotPassword"
                            component={AuthenticationContainer}
                            onEnter={this.alreadyLoggedIn}
                        />
                        <Route
                            exact
                            path="/d2city"
                            component={CityContainer}
                            onEnter={null}
                        />
                        <Route
                            exact
                            path="/diwali"
                            component={CityFestivalContainer}
                            onEnter={null}
                        />
                        <Route
                            exact
                            path="/filmcityhr"
                            component={FilmCityHRContainer}
                            onEnter={null}
                        />
                        <Route
                            exact
                            path="/filmcitytest"
                            component={FilmCityTestContainer}
                            onEnter={null}
                        />
                        <Route
                            exact
                            path="/globemap"
                            component={GlobeMapContainer}
                            onEnter={null}
                        />
                        <Route
                            exact
                            path="/ipsos"
                            component={IpSosContainer}
                            onEnter={null}
                        />
                    </Route>
                    <Route path="*" exact={true} component={ErrorPage} />
                </Router>
            </div>
        );
        if (!this.state.rehydrated) {
            returnValue = <div />;
        }
        return returnValue;
    }
}

const AuthenticatedLayout = (props) => {
    return <div>{props.children}</div>;
};

const UnauthenticatedLayout = (props) => <div>{props.children}</div>;

export default App;
